// @flow
import { isTeamDiscipline, getTeamDisciplineName } from 'constants/disciplines';
import { getDisciplineName } from 'helpers';

export const getDisciplineTitle = (disciplineId: number) => {
  return isTeamDiscipline(disciplineId)
    ? getTeamDisciplineName(disciplineId)
    : getDisciplineName(disciplineId);
};
